import React from "react";
import { ReactComponent as Phone } from "assets/svgs/phone.svg";
import { ReactComponent as Contact } from "assets/svgs/contact.svg";
import { ReactComponent as Location } from "assets/svgs/location.svg";
import RichText from "components/rich-text";

const ContactInfo = ({ data }) => (
    <>
        {
            data?.phone && (
                <div className="contact-info w-2/3">
                    <Phone fill="white" />
                    <RichText value={data?.phone?.data} />
                </div>
            )
        }
        {
            data?.contact && (
                <div className="contact-info w-1/3">
                    <Contact fill="white" />
                    <RichText value={data?.contact?.data} />
                </div>
            )
        }
        {
            data?.location && (
                <div className="contact-info w-1/3">
                    <Location fill="white" />
                    <RichText value={data?.location?.data} />
                </div>
            )
        }
    </>
);

export default ContactInfo;
